export default __webpack_public_path__ + "static/media/pt-card-bg.d63ed347.svg";